export * from './lms-table-wrapper.component';
